import { useHistory } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { Box } from '@mui/material';
import classNames from 'classnames';

import Link from 'Lib/components/common/Link';
import isEmpty from 'Lib/utilities/isEmpty';
import isFunction from 'Lib/utilities/isFunction';

function PageHeader(props) {
    const { breadcrumbs, className, title, subTitle, hideBreadcrumbs, forceActionDropDown = false } = props;
    const history = useHistory();

    const openExternal = url => {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.rel = 'noopener noreferrer';
        anchor.target = '_blank';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };

    const renderActions = () => {
        if (isFunction(props.renderActions)) {
            return props.renderActions();
        }

        const { actions } = props;

        if (!actions) {
            return null;
        }

        let actionList = [];

        if (isFunction(actions)) {
            actionList = actions();
        } else {
            actionList = actions;
        }

        if (!actionList || isEmpty(actionList)) {
            return null;
        }

        if (actionList.length == 1 && forceActionDropDown == false) {
            const action = actionList[0];
            const { color = 'primary' } = action;

            if (action.to) {
                // Omit passing of primary (throws console errors when passing to DOM)
                const { disabled, to, primary, ...rest } = action;

                if (action.external) {
                    return (
                        <Button color={color} disabled={disabled} onClick={() => openExternal(action.to)}>
                            {action.icon ? (
                                <>
                                    <i className={`${action.icon}`}></i>
                                    {'  '}
                                </>
                            ) : null}
                            {action.label}
                        </Button>
                    );
                }

                return (
                    <Link to={to} {...rest}>
                        <Button color={color} disabled={disabled} onClick={() => history.push(to)}>
                            {action.icon ? (
                                <>
                                    <i className={`${action.icon}`}></i>
                                    {'  '}
                                </>
                            ) : null}
                            {action.label}
                        </Button>
                    </Link>
                );
            }

            if (action.onClick) {
                const { color = 'primary', disabled } = action;

                return (
                    <Button onClick={action.onClick} color={color} disabled={disabled}>
                        {action.icon ? (
                            <>
                                <i className={`${action.icon}`}></i>&nbsp;&nbsp;
                            </>
                        ) : null}
                        {action.label}
                    </Button>
                );
            }
        } else {
            return (
                <UncontrolledDropdown>
                    <DropdownToggle caret style={{ borderRadius: '40px', backgroundColor: '#02893F' }}>
                        Actions
                    </DropdownToggle>
                    <DropdownMenu right>
                        {actionList.map((action, index) => {
                            if (action.divider) return <DropdownItem key={index} divider />;

                            if (action.external) {
                                return (
                                    <DropdownItem style={{ color: '#3E8FAB' }} key={index} onClick={() => openExternal(action.to)}>
                                        {action.label}
                                    </DropdownItem>
                                );
                            }

                            if (action.to) {
                                // Omit passing of primary (throws console errors when passing to DOM)
                                const { to, primary, ...rest } = action;

                                return (
                                    <DropdownItem key={index} onClick={() => history.push(to)}>
                                        <Link key={index} to={to} {...rest}>
                                            {action.label}
                                        </Link>
                                    </DropdownItem>
                                );
                            }

                            if (action.onClick) {
                                return (
                                    <DropdownItem key={index} onClick={action.onClick} color={action.color}>
                                        <Box sx={{ color: action.color == 'danger' ? 'error.main' : 'link.main' }}>{action.label}</Box>
                                    </DropdownItem>
                                );
                            }
                        })}
                    </DropdownMenu>
                </UncontrolledDropdown>
            );
        }
    };

    const renderBreadcrumbs = () => {
        if (hideBreadcrumbs) return null;

        return (
            <div className="page-breadcrumb">
                <Breadcrumb>
                    <BreadcrumbItem>
                        <Link to="/">
                            <i className="fal fa-home">
                                <span className="sr-only">Home</span>
                            </i>{' '}
                            Home
                        </Link>
                    </BreadcrumbItem>
                    {breadcrumbs
                        ? breadcrumbs.map(({ label, url, active = false }, index) => (
                              <BreadcrumbItem key={index} active={active}>
                                  {url ? <Link to={url}>{label}</Link> : <>{label}</>}
                              </BreadcrumbItem>
                          ))
                        : null}
                </Breadcrumb>
            </div>
        );
    };

    return (
        <header>
            {renderBreadcrumbs()}
            <div className={classNames('page-header', className)}>
                <div className="page-header-heading">
                    <div data-cy="page-header" className="page-header-title" style={hideBreadcrumbs ? { paddingTop: '1em' } : {}}>
                        {title}
                    </div>
                    {subTitle ? <div className="page-header-subtitle">{isFunction(subTitle) ? subTitle() : subTitle}</div> : null}
                </div>
                <div className="page-header-actions">{renderActions()}</div>
            </div>
        </header>
    );
}

export default PageHeader;
